import AdminEleven from "@/layouts/AdminEleven.vue";

export const reportsRoutes = [
  {
    name: "reports",
    path: "/reports",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "receiveds",
        path: "/recebiveis",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/Receiveds.vue"
          ),
        meta: {
          title: "Relatório de recebiveis",
          requiresAuth: true,
        },
      },
      {
        name: "cancellation",
        path: "/cancelamento",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/Cancellation.vue"
          ),
        meta: {
          title: "Cancelamento",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "channelsSales",
        path: "/vendas-por-canal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByChannel.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Canal",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salesByDay",
        path: "/venda-por-dia",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByDay.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Dia",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "consumerFiscalNote",
        path: "/nfconsumidorfinal",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/ConsumerFiscalNote.vue"
          ),
        meta: {
          title: "Relatório NF Consumidor Final",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salesByPaymentMethod",
        path: "/venda-por-forma-pagamento",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByPaymentMethod.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Forma de Pagamento",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salesByEvent",
        path: "/venda-por-evento",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByEvent.vue"
          ),
        meta: {
          title: "Relatório de vendas por evento",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salesByTicket",
        path: "/venda-por-ingresso",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByTicket.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Produto",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salesByPointOfSale",
        path: "/venda-por-ponto-de-venda",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/SalesByPointOfSale.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Ponto de Venda",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "discountCouponReport",
        path: "/cupons-de-desconto",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/DiscountCoupon.vue"
          ),
        meta: {
          title: "Relatório de Vendas por Produto",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "packegeEmission",
        path: "/emissao-pacote",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/sintetics/PackageEmission.vue"
          ),
        meta: {
          title: "Relatório de Emissão de Pacotes",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "generalAnalytical",
        path: "/analitico-geral",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/GeneralAnalytical.vue"
          ),
        meta: {
          title: "Relatório Analítico Geral",
          requiresAuth: true,
          requiresAdminProfile: false,
        },
      },
      {
        name: "generalAnalyticalEleventickets",
        path: "/analitico-geral-eleventickets",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/GeneralAnalyticalEleventickets.vue"
          ),
        meta: {
          title: "Analítico Geral ElevenTickets",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "validationAnalytical",
        path: "/analitico-validacao",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/ValidationAnalytical.vue"
          ),
        meta: {
          title: "Relatório de Validacao",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "financialAnalytical",
        path: "/financeiro-por-produtor",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/FinancialAnalytical.vue"
          ),
        meta: {
          title: "Relatório Analítico Financeiro",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "financialAnalyticalEleventickets",
        path: "/analitico-financeiro-eleventickets",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/FinancialAnalyticalEleventickets.vue"
          ),
        meta: {
          title: "Relatório Analítico Financeiro ElevenTickets",
          requiresAuth: false,
          requiresAdminProfile: true,
        },
      },
      {
        name: "consumerAnalytical",
        path: "/analitico-consumidores-eleventickets",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/ConsumerAnalytical.vue"
          ),
        meta: {
          title: "Relatório Analítico Consumidores ElevenTickets",
          requiresAuth: false,
          requiresAdminProfile: true,
        },
      },
      {
        name: "consumerDailyAnalytical",
        path: "/analitico-vendas-diarias",

        // Componente que renderiza o Relatório Diário de Vendas
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/ConsumerDailyAnalytical.vue"
          ),
        meta: {
          title: "Relatório Analítico Consumidores ElevenTickets",
          requiresAuth: false,
          requiresAdminProfile: true,
        },
      },
      {
        name: "productsSales",
        path: "/vendas-de-produtos",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/reports/analytics/ProductsSales.vue"
          ),
        meta: {
          title: "Relatório de Vendas de Produtos Eleventickets",
          requiresAuth: false,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
